import { render, staticRenderFns } from "./TwoSidesModal.vue?vue&type=template&id=469a3e36&"
import script from "./TwoSidesModal.vue?vue&type=script&lang=js&"
export * from "./TwoSidesModal.vue?vue&type=script&lang=js&"
import style0 from "./TwoSidesModal.vue?vue&type=style&index=0&id=469a3e36&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports